'use client';

import { Button } from '@components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@components/ui/form';
import { Input } from '@components/ui/input';
import { Textarea } from '@components/ui/textarea';
import { useTranslations } from 'next-intl';
import Container from '@components/Container';
import AnimatedHeadings from '@components/AnimatedHeadings';
import styles from './index.module.scss';
import AnimatedParagraphs from '@components/AnimatedParagraphs';
import { useContactForm } from './useContactForm';

const ContactForm = () => {
  const t = useTranslations('contact');
  const { form, onSubmit } = useContactForm();

  return (
    <Container id={'contact'} dataId={'contact'}>
      <AnimatedHeadings
        el="h1"
        className={styles.sectionTitle}
        text={t('heading')}
        repeatDelay={10000}
      />
      <AnimatedParagraphs className="text-base sm:text-lg md:text-xl">
        {t('description')}
      </AnimatedParagraphs>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className={styles.form}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="focus-within:text-[#1efcf9d9] transition duration-300 ease-in-out">
                <FormLabel className="text-base sm:text-lg">
                  {t('name')}
                </FormLabel>
                <FormControl>
                  <Input placeholder="Name" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="focus-within:text-[#1efcf9d9] transition duration-300 ease-in-out">
                <FormLabel className="text-base sm:text-lg">
                  {t('email')}
                </FormLabel>
                <FormControl>
                  <Input placeholder="Email" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="message"
            render={({ field }) => (
              <FormItem className="focus-within:text-[#1efcf9d9] transition duration-300 ease-in-out">
                <FormLabel className="text-base sm:text-lg">
                  {t('message')}
                </FormLabel>
                <FormControl>
                  <Textarea
                    placeholder="Write us a message"
                    {...field}
                    className="resize-none overflow-hidden whitespace-pre-wrap"
                    onInput={(e) => {
                      const target = e.target as HTMLTextAreaElement;
                      target.style.height = 'auto';
                      target.style.height = `${target.scrollHeight}px`;
                    }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <Button type="submit" className={styles.button}>
            {t('button')}
          </Button>
        </form>
      </Form>
    </Container>
  );
};

export default ContactForm;
